import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';
import { syncDateLibrariesLocale } from '@helpers/dateHelpers';

dayjs.extend(relativeTime);
dayjs.extend(updateLocale);

export const useDateLocale = () => {
  const { i18n } = useTranslation();

  syncDateLibrariesLocale();

  useEffect(() => {
    syncDateLibrariesLocale();
  }, [i18n.resolvedLanguage]);
};
